import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useLoadActiveData } from "../../hooks/useLoadActiveData";
import { useSelector } from "react-redux";

const ObjekteListeWrapper = ({ children }) => {
  const { fetchWithAuth, accessToken } = useAuth();
  const [objekte, setObjekte] = useState([]);
  const [loading, setLoading] = useState(true);
  const filters = useSelector(state => state.filters);
  const source = {...filters};

  const {
    kategorienAktiv: kategorien,
    ablageorteAktiv: ablageorte,
    typenAktiv: typen,
    laenderAktiv: laender,
    materialienAktiv: materialien,
    waehrungenAktiv: waehrungen,
    zustaendeAktiv: zustaende,
    eigentuemerAktiv: eigentuemer,
    loading: metaLoading,
    error,
  } = useLoadActiveData();

  useEffect(() => {
    const fetchObjekte = async () => {
      try {
        const params = new URLSearchParams();

        // Disable pagination
        params.set("page_size", 99999);

        if (source.kategorie) params.append("kategorie", source.kategorie);
        if (source.ablageort) params.append("ablageort", source.ablageort);
        if (source.typ) params.append("typ", source.typ);
        if (source.land) params.append("land", source.land);
        if (source.material) params.append("material", source.material);
        if (source.waehrung) params.append("waehrung", source.waehrung);
        if (source.zustand) params.append("zustand", source.zustand);
        if (source.eigentuemer) params.append("eigentuemer", source.eigentuemer);
        if (filters.jahrgangMin) params.append("jahrgang_min", filters.jahrgangMin);
        if (filters.jahrgangMax) params.append("jahrgang_max", filters.jahrgangMax);
        
        const response = await fetchWithAuth(`/api/main/?${params}`, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();
        const resultArray = Array.isArray(data) ? data : data.results;
        setObjekte(resultArray);

      } catch (err) {
        console.error("Fehler beim Laden der Objekte:", err);
      } finally {
        setLoading(false);
      }
    };

    if (accessToken) fetchObjekte();
  }, [accessToken, filters]);

  const allMetadataReady = [
    kategorien,
    ablageorte,
    typen,
    laender,
    materialien,
    waehrungen,
    zustaende,
    eigentuemer,
  ].every((arr) => Array.isArray(arr) && arr.length > 0);

  if (loading || !allMetadataReady) {
    return <div>Lade Dashboard...</div>;
  }
  if (error) return <div className="text-danger">Fehler beim Laden: {error}</div>;

  return children(objekte, {
    kategorien,
    ablageorte,
    typen,
    laender,
    materialien,
    waehrungen,
    zustaende,
    eigentuemer,
  });
};

export default ObjekteListeWrapper;
